import { render, staticRenderFns } from "./DocumentSelectorCardStyle.vue?vue&type=template&id=56f44068&scoped=true&"
import script from "./DocumentSelectorCardStyle.vue?vue&type=script&lang=ts&"
export * from "./DocumentSelectorCardStyle.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentSelectorCardStyle.vue?vue&type=style&index=0&id=56f44068&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f44068",
  null
  
)

export default component.exports